<template>
  <div class="ConceptosListado m-t-16">
    <md-table-card> <!--md-table-card class="m-t-16"-->
      <md-toolbar>
        <h1 class="md-title">Conceptos de nómina registrados</h1>
      </md-toolbar>
      <md-table>
        <md-table-header>
          <md-table-row>
            <md-table-head>Concepto</md-table-head>
            <md-table-head>Tipo</md-table-head>
            <md-table-head>Importe</md-table-head>
            <md-table-head>Estatus</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="concepto in conceptos" :key="concepto">
            <md-table-cell>{{concepto.desc_con}}</md-table-cell>
            <md-table-cell>{{concepto.tipo_con.toUpperCase()}}</md-table-cell>
            <md-table-cell>{{ Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(concepto.importe_cnh) }}</md-table-cell>
            <md-table-cell>{{concepto.estatus_con.toUpperCase()}}</md-table-cell>
            <md-table-cell>
              <md-button class="md-icon-button" @click.native="modalEditarConcepto(concepto)">
                <md-icon>edit</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
    </md-table-card>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEditarConcepto">
      <md-dialog-title>{{concepto.desc_con}}</md-dialog-title>
      <md-dialog-content>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_desc }">
          <label>Concepto</label>
          <md-input v-model="concepto.desc_con" required></md-input>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_tipo }">
          <label>Tipo</label>
          <md-select name="tipo_con" id="tipo_con" v-model="concepto.tipo_con" required>
            <md-option value="percepcion">Percepción</md-option>
            <md-option value="deduccion">Deducción</md-option>
          </md-select>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_importe }">
          <label>Importe</label>
          <md-input v-model="concepto.importe_cnh" type="number" min="0" step=".01" required></md-input>
        </md-input-container>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_tipo }">
          <label>Estatus</label>
          <md-select name="estatus_con" id="estatus_con" v-model="concepto.estatus_con" required>
            <md-option value="activo">Activo</md-option>
            <md-option value="inactivo">Inactivo</md-option>
          </md-select>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalEditarConcepto()">Cancelar</md-button>
        <md-button @click.native="guardarCambiosConcepto()" class="md-primary md-raised">Guardar cambios</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
export default {
  name: "ConceptosListado",
  methods: {
    obtenerConceptos() {
      this.$http
        .post("conceptos", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            if (response.status === 200 && "conceptos" in response.body) {
              this.conceptos = response.body.conceptos;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    modalEditarConcepto(concepto) {
      this.concepto = concepto;
      this.$refs["modalEditarConcepto"].open();
    },
    cerrarModalEditarConcepto() {
      this.concepto = null;
      this.$refs["modalEditarConcepto"].close();
    },
    guardarCambiosConcepto() {
      if (this.validarCamposConcepto()) {
        this.$http
          .post("conceptos/actualizar", {
            id: this.concepto.concepto,
            data: this.concepto,
            token: this.$session.get("token")
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.cerrarModalEditarConcepto();
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposConcepto() {
      !this.concepto.desc_con
        ? (this.val.v_desc = true)
        : (this.val.v_desc = false);
      !this.concepto.importe_cnh
        ? (this.val.v_importe = true)
        : (this.val.v_importe = false);
      !this.concepto.tipo_con
        ? (this.val.v_tipo = true)
        : (this.val.v_tipo = false);
      if (this.val.v_desc || this.val.v_importe || this.val.v_tipo) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerConceptos();
  },
  updated() {
    $(".md-table table").DataTable();
  },
  data() {
    return {
      conceptos: [],
      concepto: {
        desc_con: null,
        tipo_con: null,
        estatus_con: null,
        id_con_cnh: null,
        desde_cnh: null,
        hasta_cnh: null,
        importe_cnh: null,
        concepto: null
      },
      val: {
        v_desc: null,
        v_tipo: null,
        v_estatus: null,
        v_importe: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// ConceptosListado.vue?4b6c0e09